import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { getApi } from '../api';

export type PostAccountShipmentsBulkDeleteVariables = {
  accountId: number;
  ids: number[];
};

/**
 * POST `/api/accounts/{account}/shipments/bulk/delete` — delete shipments.
 */
export default function usePostAccountShipmentsBulkDelete() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      accountId,
      ids,
    }: PostAccountShipmentsBulkDeleteVariables) => {
      const { api, baseURL } = getApi();
      const res = await api.post(
        `/api/accounts/${accountId}/shipments/bulk/delete`,
        { ids },
        { baseURL },
      );
      return res.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['account-shipments', variables.accountId],
      });
      queryClient.invalidateQueries({
        queryKey: ['account-shipment-metrics', variables.accountId],
      });
    },
  });
}
